import { type ISchema, ObjectSchema } from 'yup';

export const ReferenceMetaKey = 'engineReference';

export function isReferenceSchema(schema: ISchema<any>) {
  return (
    schema instanceof ObjectSchema && schema.meta()?.[ReferenceMetaKey] === true
  );
}
